const ParticipantVideoTrackType = {
  camera: 'camera',
  screenShare: 'screenShare',
};

export default ParticipantVideoTrackType;
